<template>
  <v-layout style="display: grid;grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));">
    <div class="antialiased bg-gray-30 dark:bg-gray-900">
      <!-- <NavBar ref="navbar" v-if="IS_USER_AUTHENTICATED" @collapse-sidebar="collapseSideBar"/> -->
      <NavBar ref="navbar" v-if="IS_USER_AUTHENTICATED"/>
      <SideBar ref="sidebar" v-if="IS_USER_AUTHENTICATED" />
      <v-main :class="{'p-4 md:ml-20 h-auto pt-20': IS_USER_AUTHENTICATED, 'w-full h-screen': !IS_USER_AUTHENTICATED}">
        <!-- <router-view @collapse-sidebar="collapseSideBar"/> -->
        <router-view/>
      </v-main>
    </div>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex';
import NavBar from "./components/NavBar";
import SideBar from "./components/SideBar";

//import { GET_USERNAME } from "./store/storeconstants";
export default {
  name: "App",
  data() {
    return {
      drawer: true,
      rail: true,
    };
  },
  components: {
    NavBar,
    SideBar,
  },
  computed: {
    ...mapState({
      username: state => state.users.username,
      IS_USER_AUTHENTICATED: state => state.authenticated
    })
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push('/login');
    },
    // collapseSideBar() {
    //   this.$refs.sidebar.collapseSideBar();
    // }
  },
  mounted() {
    // this.$store.commit("initializeStore");
  },
  watch: {
    // $route() {
    //   this.$forceUpdate();
    // }
  }
};
</script>
<style scoped>
.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}
</style>